import React from "react";
import {Card} from "react-bootstrap";
import {Cell, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";

const DashboardRcj = ({ rcjData }) => {

    const valuesById = rcjData.rcjData?.values || {};
    const fields = rcjData.rcjData?.group?.custom_fields || [];
    console.log(rcjData);

    const getFieldValue = (fieldLabel) => {
        const field = fields.find(f => f.field_name === fieldLabel);
        if (!field) return '';
        const raw = valuesById[field.id];
        return typeof raw === 'string' ? raw.trim() : raw;
    };

    const COLORS = ['#42a5f5', '#ef5350', '#66bb6a', '#ffa726', '#ab47bc', '#26c6da'];

    const renderPercentPieChart = (field, index) => {
        const raw = valuesById[field.id];
        const value = parseFloat(String(raw).replace('%', '').replace(',', '.'));
        const rest = Math.max(0, 100 - value);

        const data = [
            { name: field.field_name, value },
            { name: 'Restante', value: rest }
        ];

        const renderCenterLabel = ({ cx, cy }) => {
            return (
                <text
                    x={cx}
                    y={cy}
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize="18"
                    fontWeight="bold"
                    fill="#333"
                >
                    {`${value.toFixed(1)}%`}
                </text>
            );
        };

        return (
            <div key={field.id} style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <strong style={{ fontSize: '0.9rem', display: 'block', marginBottom: '0.5rem' }}>
                    {field.field_name}
                </strong>
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={30}
                            outerRadius={90}
                            dataKey="value"
                            startAngle={90}
                            endAngle={-270}
                            stroke="none"
                            label={renderCenterLabel}
                            labelLine={false}
                        >
                            {data.map((entry, i) => (
                                <Cell key={`cell-${i}`} fill={i === 0 ? COLORS[index % COLORS.length] : '#e8f5e9'} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    };

    return (
        <div className="rcj_container">
            <h1 className="rcj_titulo">{rcjData?.group?.group_name || "Estadísticas de Juventudes"}</h1>
            <div className="rcj_badge">
                Clasificación: {getFieldValue("Clasificación General (Ficha)")}
            </div>

            <div className="rcj_section">
                <Card>
                    <Card.Header className="bg-secondary text-black rcj_titulo_seccion rcj_bg_yellow">
                        <h5 className="mb-0" style={{ marginTop: '5px' }}>Demografía General</h5>
                    </Card.Header>
                    <Card.Body>
                        <div className="rcj_fila">
                            <div className="rcj_col_izq">
                                <div className="rcj_dato">
                                    <div className="rcj_icon rcj_cyan">
                                        <i className="bi bi-person"></i>
                                    </div>
                                    <div>
                                        <div className="rcj_valor">{getFieldValue("Habitantes por Comuna")}</div>
                                        <div className="rcj_etiqueta">Habitantes por Comuna</div>
                                    </div>
                                </div>
                                <div className="rcj_dato">
                                    <div className="rcj_icon rcj_pink">
                                        <i className="bi bi-person"></i>
                                    </div>
                                    <div>
                                        <div className="rcj_valor">{getFieldValue("Habitantes Jóvenes por Comuna")}</div>
                                        <div className="rcj_etiqueta">Habitantes Jóvenes</div>
                                    </div>
                                </div>
                                <div className="rcj_titulo_seccion rcj_bg_teal">Indicadores Sociales</div>
                                <div className="rcj_dato">
                                    <div className="rcj_icon rcj_blue">
                                        <i className="bi bi-bar-chart"></i>
                                    </div>
                                    <div>
                                        <div className="rcj_valor">{getFieldValue("Índice de Institucionalidad Municipal Juvenil (IIMJ)")}</div>
                                        <div className="rcj_etiqueta">IIMJ</div>
                                    </div>
                                </div>
                                <div className="rcj_dato">
                                    <div className="rcj_icon rcj_red">
                                        <i className="bi bi-bar-chart-fill"></i>
                                    </div>
                                    <div>
                                        <div className="rcj_valor">{getFieldValue("Índice de Priorización Juvenil (IPJ)")}</div>
                                        <div className="rcj_etiqueta">IPJ</div>
                                    </div>
                                </div>
                                <div className="rcj_dato rcj_alerta">
                                    <strong>Nivel Institucionalidad:</strong> {getFieldValue("Nivel Institucionalidad Municipal Juvenil")}<br />
                                    Nivel Priorización Juventud: {getFieldValue("Nivel Priorización Juventudes")}
                                </div>
                            </div>
                            <div className="rcj_col_der">
                                {renderPercentPieChart(fields.find(f => f.field_name === "Tasa de % Juventudes Comunal"), 0)}
                                {renderPercentPieChart(fields.find(f => f.field_name === "Tasa de % Juventudes Regional"), 1)}
                                {renderPercentPieChart(fields.find(f => f.field_name === "Desempleo Juvenil, ENE"), 2)}
                            </div>
                        </div>

                        <div className="rcj_section">
                            <div className="rcj_titulo_seccion rcj_bg_green">Misión OMJ</div>
                            <p className="rcj_mision">
                                {getFieldValue("Misión OMJ")}
                            </p>
                        </div>
                    </Card.Body>
                </Card>
            </div>

        </div>
    );
}


export default DashboardRcj;